"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
exports.default = theme => ({
    root: {
        height: constants_1.MIN_TARGET_SIZE + 2,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        boxSizing: 'border-box',
        appearance: 'none',
        flexShrink: 0,
        flexGrow: 1,
        cursor: 'default',
        outline: 'none',
        paddingLeft: 7,
        paddingRight: 14,
        backgroundColor: theme.indigo3,
        fontSize: 14,
        fontWeight: 400,
        color: theme.white1,
        position: 'relative',
        marginLeft: 0,
        marginRight: 0,
        '&:hover:not(:focus)': {
            backgroundColor: theme.indigo2
        },
        '&:focus': {
            backgroundColor: theme.indigo1
        },
        '&::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
        }
    },
    label: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    prefix: {
        marginRight: 7,
        width: 14,
        flexShrink: 0
    }
});
//# sourceMappingURL=option.style.js.map